<template>
	<div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

		<h1>Relatório de Processos</h1>

		<div class="row" style="font-size: small;">
			<div class="col-12">
				<div style="text-align: right; width: 100%;" class="mb-3">
					<button type="button" class="btn btn-sm btn_branco" @click="Imprimir();">
						<label class="btn_branco_lbl">Imp<u>r</u>imir</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" style="width: 130px;" @click="gerarCSV();">
						<label class="btn_branco_lbl"><u>G</u>erar Planilha</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco">
						<label class="btn_branco_lbl"><u>B</u>uscar</label>
					</button>

					<button type="button" class="btn btn-sm btn_branco" @click="Voltar();">
						<label class="btn_branco_lbl"><u>V</u>oltar</label>
					</button>
				</div>
			</div>
		</div>

		<div class="form-container mt-4 mb-3">
			<div class="row" style="font-size: small;">
				<div class="form-group mt-4 col-3">
					<label for="label" class="input-label"><strong>Localidade:</strong></label>
					<select class="form-control custom-select-sm custom-dropdown" v-model="cidade_selecionado" @change="EfetivarBusca()">
						<option value="">Todos</option>
						<option v-for="cidade in cidades" :key="cidade.id" :value="cidade.id">{{ cidade.descricao }}</option>
					</select>
				</div>

				<div class="form-group mt-4 col-6">
					<label for="label" class="input-label"><strong>V<u>a</u>ra Estadual:</strong></label>
					<input type="text" id="vara_estadual" class="form-control"> <!-- Esse campo não está ativo na consulta -->
				</div>

				<div class="form-group mt-4 col-3">
					<label for="label" class="input-label"><strong>Juízo:</strong></label>
					<input type="text" id="juizo" class="form-control"> <!-- Esse campo não está ativo na consulta -->
				</div>
			</div>
			<div class="row" style="font-size: small;">
				<div class="form-group mt-4 col-5">
					<label for="label" class="input-label"><strong>Rito Processo:</strong></label>
					<select class="form-control custom-select-sm custom-dropdown" v-model="rito_selecionado" @change="EfetivarBusca()">
						<option value="">Todos</option>
						<option v-for="rito in ritos" :key="rito.id" :value="rito.id">{{ rito.descricao }}</option>
					</select>
				</div>
				<div class="form-group mt-4 col-3">
					<label for="label" class="input-label"><strong>Prazo:</strong></label>
					<select class="form-control custom-select-sm custom-dropdown" v-model="prazo_selecionado" @change="EfetivarBusca()">
						<option value="">Todos</option>
					</select>
				</div>
				<div class="form-group mt-4 col-2">
					<label for="label" class="input-label"><strong>Data Início:</strong></label>
					<input type="date" id="data_inicio" class="form-control" v-model="data_inicio" @change="EfetivarBusca()">
				</div>
				<div class="form-group mt-4 col-2">
					<label for="label" class="input-label"><strong>Data Fim:</strong></label>
					<input type="date" id="data_fim" class="form-control" v-model="data_fim" @change="EfetivarBusca()">
				</div>
			</div>
			<div class="row" style="font-size: small;">
				<div class="form-group mt-4 col-2">
					<label for="label" class="input-label"><strong>Data da Intimação:</strong></label>
					<input type="date" id="data_intimacao" class="form-control" v-model="data_intimacao" @change="EfetivarBusca()">
				</div>
				<div class="form-group mt-4 col-5">
					<label for="label" class="input-label"><strong>Nível de Sigilo do Processo?</strong></label>
					<select class="form-control custom-select-sm custom-dropdown" v-model="nivel_sigilo_selecionado" @change="EfetivarBusca()">
						<option value="">Todos</option>
						<option value="0">Sem Sigilo (Nível 0)</option>
						<option value="1">Com Sigilo (Nível 1)</option>
					</select>
				</div>
				<div class="form-group mt-4 col-5">
					<label for="label" class="input-label"><strong>Situação do processo:</strong></label>
					<input type="text" class="form-control" v-model="situacao_processo" @input="EfetivarBusca();">
				</div>

			</div>
			<div class="row" style="font-size: small;">
				<div class="form-group mt-4 col-2">
					<label for="label" class="input-label"><strong>Assunto Judicial:</strong></label>
					<input type="date" id="assunto_judicial" class="form-control" v-model="assunto_judicial"> <!-- Esse campo não está ativo na consulta -->
				</div>
				<div class="form-group mt-4 col-5">
					<label for="label" class="input-label"><strong><u>C</u>lasse do Processo:</strong></label>
					<select class="form-control custom-select-sm custom-dropdown" v-model="classe_processual_selecionada" @change="EfetivarBusca()">
						<option :value="null">Todos</option>
						<option v-for="classe in classes_processuais" :key="classe.id" :value="classe.id">{{ classe.descricao }}</option>
					</select>
				</div>
				<div class="form-group mt-4 col-5">
					<label for="label" class="input-label"><strong>Data Autuação:</strong></label>
					<input type="text" class="form-control" v-model="data_autuacao" @input="EfetivarBusca()">
				</div>
			</div>

			<div class="row" style="font-size: small;">
				<div class="form-group mt-4 col-4">
					<label for="label" class="input-label"><strong>Processo relacio<u>n</u>ado:</strong></label>
					<input type="text" class="form-control" v-model="processo_relacionado" @input="EfetivarBusca()">
				</div>
				<div class="form-group mt-4 col-4">
					<label for="label" class="input-label"><strong>Tipo Tema:</strong></label>
					<input type="text" id="tipo_tema" class="form-control"> <!-- Esse campo não está ativo na consulta -->
				</div>
				<div class="form-group mt-4 col-4">
					<label for="label" class="input-label"><strong>Situação Tema:</strong></label>
					<input type="text" id="situacao_tema" class="form-control"> <!-- Esse campo não está ativo na consulta -->
				</div>

				<div class="form-group mt-4 col-12">
					<input type="checkbox" v-model="listar_processos_baixados">
					<label for="label" class="input-label">&nbsp;Listar processos baixados</label> <!-- Esse campo não está ativo na consulta -->
				</div>
			</div>

			<div v-if="user.is_admin" class="mt-3 p-3 border rounded" style="font-size: small; background-color: lightgray;">
				<div class="row">
					<div class="col-12">
						<span style="color: black; font-size: 14px; font-style: italic;">
							Os filtros a seguir são exclusivos deste simulador por se tratarem de ferramentas pedagógicas para a simulação.
						</span>
					</div>
				</div>

				<div class="row">
					<div class="form-group mt-3 col-6">
						<label for="turma_pedagogica" class="input-label"><strong>Turma:</strong></label>
						<select id="turma_pedagogica" class="form-control custom-select-sm custom-dropdown" v-model="turma_selecionada" @change="EfetivarBusca()">
							<option value="">Todos</option>
							<option v-for="turma in turmas" :key="turma.id" :value="turma.id">{{ turma.descricao }}</option>
						</select>
					</div>

					<div class="form-group mt-3 col-6">
						<label for="competencia_pedagogica" class="input-label"><strong>Competência:</strong></label>
						<select id="competencia_pedagogica" class="form-control custom-select-sm custom-dropdown" v-model="competencia_selecionada" @change="EfetivarBusca()">
							<option value="">Todos</option>
							<option v-for="competencia in competencias" :key="competencia.id" :value="competencia.id">{{ competencia.descricao }}</option>
						</select>
					</div>
				</div>
			</div>

			<div style="text-align: left; width: 100%;" v-if="!user.is_admin">
				<span style="color: darkgray; font-size: small;">* Esta tela só exibe os processos que você tem alguma relação com as partes.</span>
			</div>

		</div>

		<div style="text-align: right; width: 100%;" v-if="processosFiltrados.length > 0">
			<span style="color: lightgray; font-size: small;">Lista de Processos ({{ processosFiltrados.length }} registros)</span>
		</div>

		<div class="empty-results-box mt-2 mb-4" v-if="processosFiltrados.length === 0">
			Não há itens correspondentes à pesquisa.
		</div>

		<table class="table table-striped table-bordered mt-2 border" style="font-size: small;" v-if="processosFiltrados.length > 0" id="printable-section">
			<thead>
				<tr class="text-center">
					<th scope="col" style="background-color: lightgrey; display: none;">id</th>
					<th scope="col" style="background-color: lightgrey;"> <input type="checkbox" value="1" /> </th>

					<!-- <th scope="col" style="background-color: lightgrey;">Nº Processo</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('codigo_processo')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'codigo_processo' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'codigo_processo' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Número Processo</span>
						</div>
					</th>

					<!-- <th scope="col" style="background-color: lightgrey;">Classe</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('classe_processual.descricao')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'classe_processual.descricao' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'classe_processual.descricao' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Classe</span>
						</div>
					</th>

					<!-- <th scope="col" style="background-color: lightgrey;">Autores Principais</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('autoresPrincipais')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'autoresPrincipais' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'autoresPrincipais' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Autores Principais</span>
						</div>
					</th>

					<!-- <th scope="col" style="background-color: lightgrey;">Réus</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('reus')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'reus' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'reus' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Réus</span>
						</div>
					</th>

					<!-- <th scope="col" style="background-color: lightgrey;">Localidade Judicial</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('cidade.descricao')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'cidade.descricao' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'cidade.descricao' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Localidade Judicial</span>
						</div>
					</th>

					<!-- <th scope="col" style="background-color: lightgrey;">Assunto</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('assuntosDescricao')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'assuntosDescricao' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'assuntosDescricao' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Assunto</span>
						</div>
					</th>


					<!-- <th scope="col" style="background-color: lightgrey;">Último Evento</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('ultimoEvento')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'ultimoEvento' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'ultimoEvento' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Último Evento</span>
						</div>
					</th>

					<!-- <th scope="col" style="background-color: lightgrey;">Data/Hora Últ. Evento</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('ultimoEvento')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'ultimoEvento' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'ultimoEvento' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Data/Hora Últ. Evento</span>
						</div>
					</th>




					<!-- <th scope="col" style="background-color: lightgrey;">Data/Hora Autuação</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('updated_at')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'updated_at' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'updated_at' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Data/Hora Autuação</span>
						</div>
					</th>


					<!-- <th scope="col" style="background-color: lightgrey;">Valor da Causa</th> -->
					<th scope="col" style="background-color: lightgrey; cursor: pointer;" @click="ordenar('valor_causa')">
						<div class="header-content">
							<div class="sort-icons">
								<span class="material-icons" :class="ordenacao.coluna === 'valor_causa' && ordenacao.direcao === 'asc' ? 'active' : 'inactive'">keyboard_arrow_up</span>
								<span class="material-icons" :class="ordenacao.coluna === 'valor_causa' && ordenacao.direcao === 'desc' ? 'active' : 'inactive'">keyboard_arrow_down</span>
							</div>
							<span>Valor da Causa</span>
						</div>
					</th>
					<th scope="col" style="background-color: lightgrey;" v-if="user.is_admin">&nbsp;</th>
				</tr>
			</thead>
			<tbody>

				<tr v-for="processo in processosFiltrados">
					<td style="text-align: left; display: none;">{{ processo.id }}</td>
					<td scope="col" :style="{ backgroundColor: processo.classe_processual?.cor }"> <input type="checkbox" /> </td>
					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }"><a :href="`${BASE_URL}processos/movimentacao_processual/${processo.id}`" target="_blank">{{ processo.codigo_processo }}</a></td>
					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }">{{ processo.classe_processual?.descricao }}</td>
					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }">
						<div v-for="parte in processo.partes">
							<li v-if="parte.pivot.polo_ativo === 1 && parte.pivot.principal === 1" style="list-style-type: none;">
								<span class="parte_ativa">{{ parte.nome }}</span> - {{
									parte.cpf_cnpj
										? (parte.cpf_cnpj.length > 14
											? '(' + parte.cpf_cnpj + ') Pessoa Jurídica'
											: '(' + parte.cpf_cnpj + ') Pessoa Física')
										: '(CPF/CNPJ não informado)'
								}}
							</li>
						</div>
					</td>
					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }">
						<div v-for="parte in processo.partes">
							<li v-if="parte.pivot.polo_passivo === 1" style="list-style-type: none;">
								<span class="parte_ativa">{{ parte.nome }}</span> - {{
									parte.cpf_cnpj
										? (parte.cpf_cnpj.length > 14
											? '(' + parte.cpf_cnpj + ') Pessoa Jurídica'
											: '(' + parte.cpf_cnpj + ') Pessoa Física')
										: '(CPF/CNPJ não informado)'
								}}
							</li>
						</div>
					</td>

					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }">{{ processo.cidade?.descricao }}</td>
					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }">
						<li v-for="assunto in processo.assuntos" style="list-style-type: none;">
						<li>
							{{ assunto.descricao }}
						</li>
						</li>
					</td>

					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }">
						{{ processo.peticoes.length > 0 ? formatDate(processo.peticoes[processo.peticoes.length - 1].updated_at) : 'Sem petições' }}
					</td>
					<td style="text-align: left;" :style="{ backgroundColor: processo.classe_processual?.cor }">
						{{ processo.peticoes.length > 0 ? formatDate(processo.peticoes[processo.peticoes.length - 1].updated_at) : 'Sem petições' }}
					</td>
					<td style="text-align: center;" :style="{ backgroundColor: processo.classe_processual?.cor }">{{ formatDate(processo.updated_at) }}</td>
					<td style="text-align: right;" :style="{ backgroundColor: processo.classe_processual?.cor }">
						{{ processo.valor_causa ? formatCurrency(processo.valor_causa) : 'Valor não disponível' }}
					</td>

					<td style="text-align: center;" :style="{ backgroundColor: processo.classe_processual?.cor }" v-if="user.is_admin">
						<i class="fa fa-times" style="color: red; font-size: 24px; cursor: pointer;" @click="DeletarProcesso(processo.id)"></i>
					</td>


				</tr>
			</tbody>
		</table>

	</div>
</template>

<script>

	export default {
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				processosFiltrados: [...this.processos], // Cópia local dos processos


				situacao_processo: '',
				classe_processual_selecionada: null,
				classes_processuais: [],

				rito_selecionado: '',
				ritos: [],

				prazo_selecionado: '',

				nivel_sigilo_selecionado: '',

				data_autuacao: '',

				processo_relacionado: '',
				listar_processos_baixados: false,

				ordenacao: {
					coluna: '',
					direcao: 'asc' // 'asc' or 'desc'
				},

				cidade_selecionado: '',
				cidades: [],
				data_inicio: '',
				data_fim: '',
				data_intimacao: '',
				assunto_judicial: '',
				turma_selecionada: '',
				turmas: [],
				competencia_selecionada: '',
				competencias: [],

			};
		},
		props: {
			user: {
				type: Object,
				required: true,
			},
			processos: {
				type: Object,
			},
		},
		methods: {
			Imprimir() {
				window.print();
			},
			Voltar() {
				window.history.back();
			},
			formatDate(dateString) {
				const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
				return new Intl.DateTimeFormat('pt-BR', options).format(new Date(dateString));
			},
			formatCurrency(value) {
				if (value !== null && value !== undefined) {
					return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
				} else {
					return 'Valor não disponível';
				}
			},
			CarregarDados(dados_carregar) {
				axios.get(this.BASE_URL + 'buscar/dados_iniciais/' + dados_carregar)
					.then(response => {
						if (dados_carregar == 'cidades') {
							this.cidades = response.data;
						}
						else if (dados_carregar == 'ritos') {
							this.ritos = response.data;
						}
						else if (dados_carregar == 'areas') {
							this.areas = response.data;
						}
						else if (dados_carregar == 'classes') {
							this.classes_processuais = response.data;
						}
					})
					.catch(error => {
						console.error('Erro ao buscar informações da ' + dados_carregar + ':', error);
					});
			},
			CarregarCompetencias() {
				axios.get(this.BASE_URL + 'buscar/competencias')
					.then(response => {
						this.competencias = response.data;
					})
					.catch(error => {
						console.error('Erro ao buscar competências:', error);
					});
			},
			CarregarTurmas() {
				axios.get(this.BASE_URL + 'turmas/buscar_turmas')
					.then(response => {
						this.turmas = response.data;
					})
					.catch(error => {
						console.error('Erro ao buscar turmas:', error);
					});
			},
			DeletarProcesso(processoId) {
				if (!confirm("Tem certeza que deseja excluir este processo?")) {
					return;
				}

				axios.post(this.BASE_URL + 'deletarprocesso', {
					processo_id: processoId
				})
					.then(response => {
						alert('Processo excluído com sucesso!');
						// Aqui você pode remover o processo da lista local:
						this.processosFiltrados = this.processosFiltrados.filter(p => p.id !== processoId);
					})
					.catch(error => {
						console.error('Erro ao deletar processo:', error);
						alert('Erro ao excluir o processo.');
					});
			},
			CarregarClasses() {
				this.CarregarDados('classes');
				this.CarregarDados('ritos');
			},

			EfetivarBusca() {
				//campos filtro

				const SituacaoProcesso = this.situacao_processo;
				const nivelSigiloSelecionado = this.nivel_sigilo_selecionado;
				const ritoSelecionado = this.rito_selecionado;
				const classeProcessualSelecionada = this.classe_processual_selecionada;
				const dataAutuacao = this.data_autuacao;
				const processoRelacionado = this.processo_relacionado;
				const listarProcessosBaixados = this.listar_processos_baixados;

				const cidadeSelecionada = this.cidade_selecionado;
				const dataIntimacao = this.data_intimacao;
				const dataInicio = this.data_inicio;
				const dataFim = this.data_fim;
				const turmaSelecionada = this.turma_selecionada;
				const competenciaSelecionada = this.competencia_selecionada;

				const brDateToDate = (dataBr) => {
					if (!dataBr) return null;
					const [dia, mes, ano] = dataBr.split('/');
					if (!dia || !mes || !ano) return null;
					return new Date(`${ano}-${mes}-${dia}T00:00:00`);
				};

				// type="date" retorna formato ISO (yyyy-mm-dd)
				const isoToDate = (isoStr) => {
					if (!isoStr) return null;
					return new Date(isoStr + 'T00:00:00');
				};

				const dataInicioDate = isoToDate(dataInicio);
				const dataFimDate = isoToDate(dataFim);


				//array que precisa ser filtrado
				const processos = this.processos;

				//filtrando processos
				const processosFiltrados = processos.filter(processo => {

					if (SituacaoProcesso) {
						if (!processo.codigo_processo) return false;
						if (!processo.codigo_processo.includes(SituacaoProcesso)) return false;
					}

					// Filtro por nível de sigilo
					if (nivelSigiloSelecionado !== '' && nivelSigiloSelecionado !== null && nivelSigiloSelecionado !== undefined) {
						if (processo.nivel_sigilo == null || processo.nivel_sigilo != nivelSigiloSelecionado) {
							return false;
						}
					}

					// Filtro por rito
					if (ritoSelecionado !== '' && ritoSelecionado !== undefined) {
						if (ritoSelecionado && processo.rito_area_id !== ritoSelecionado) {
							return false;
						}
					}

					// Filtro por cidade (id da cidade)
					if (cidadeSelecionada) {
						if (processo.cidade_id != cidadeSelecionada) { // != para aceitar string/number
							return false;
						}
					}

					// Filtro pedagógico por turma dos usuários vinculados ao processo
					if (turmaSelecionada) {
						const advogados = processo.advogados || [];
						const temAdvogadoNaTurma = advogados.some(advogado => {
							const turmasAdvogado = advogado.turmas || [];
							return turmasAdvogado.some(turma => turma.id == turmaSelecionada);
						});

						if (!temAdvogadoNaTurma) {
							return false;
						}
					}

					// Filtro pedagógico por competência do processo
					if (competenciaSelecionada) {
						if (processo.competencia_id != competenciaSelecionada) {
							return false;
						}
					}

					// Filtro por classe processual
					if (classeProcessualSelecionada && processo.classe_processual?.id !== classeProcessualSelecionada) {
						return false;
					}

					// Filtro por data de autuação
					if (dataAutuacao) {
						let [dia, mes, ano] = dataAutuacao.split('/');

						dia = dia == undefined ? '' : dia;
						mes = mes == undefined ? '' : mes;
						ano = ano == undefined ? '' : ano;

						const dataAutuacaoFormatted = `${ano}${mes}${dia}`;
						const processoDate = processo.created_at.split('T')[0].replace("-", "").replace("-", "");

						if (!processoDate.includes(dataAutuacaoFormatted)) {
							return false;
						}
					}

					// Filtro por data de intimação (também usando created_at do processo)
					if (dataIntimacao) {
						if (!processo.created_at) return false;

						const created = new Date(processo.created_at);
						// compara só data (sem hora)
						const createdYmd = new Date(
							created.getFullYear(),
							created.getMonth(),
							created.getDate()
						).getTime();
						const intimacaoDate = isoToDate(dataIntimacao);
						if (!intimacaoDate) return true;
						const intimacaoYmd = intimacaoDate.getTime();

						if (createdYmd !== intimacaoYmd) {
							return false;
						}
					}
					// Filtro por intervalo de prazo (petições -> campo prazo)
					if (dataInicioDate || dataFimDate) {
						const peticoes = processo.peticoes || [];

						const temPrazoNoIntervalo = peticoes.some((pet) => {
							if (!pet.prazo) return false;

							// pet.prazo vem como "YYYY-MM-DD HH:MM:SS"
							const dataPet = new Date(pet.prazo);

							// normalizar para início do dia
							const dataPetYmd = new Date(
								dataPet.getFullYear(),
								dataPet.getMonth(),
								dataPet.getDate()
							).getTime();

							let ok = true;

							if (dataInicioDate) {
								const inicioYmd = new Date(
									dataInicioDate.getFullYear(),
									dataInicioDate.getMonth(),
									dataInicioDate.getDate()
								).getTime();

								if (dataPetYmd < inicioYmd) ok = false;
							}

							if (dataFimDate) {
								const fimYmd = new Date(
									dataFimDate.getFullYear(),
									dataFimDate.getMonth(),
									dataFimDate.getDate()
								).getTime();

								if (dataPetYmd > fimYmd) ok = false;
							}

							return ok;
						});

						if (!temPrazoNoIntervalo) {
							return false;
						}
					}

					// Filtro por processo relacionado (assumindo que processo_relacionado é uma string para comparação)
					if (processoRelacionado) {
						if (!processo.codigo_processo) return false;
						if (!processo.codigo_processo.includes(processoRelacionado)) return false;
					}



					// Filtro por processos baixados (assumindo que processos baixados têm a propriedade `deleted_at` diferente de null)
					if (listarProcessosBaixados && processo.deleted_at === null) {
						return false;
					}

					return true;
				});

				// Atualiza o array de processos na tela com os processos filtrados
				this.processosFiltrados = processosFiltrados;

			},


			ordenar(coluna, toggleDirection = true) {
				if (toggleDirection) {
					this.ordenacao.direcao = this.ordenacao.coluna === coluna && this.ordenacao.direcao === 'asc' ? 'desc' : 'asc';
				}

				this.ordenacao.coluna = coluna;

				this.processosFiltrados.sort((a, b) => {
					let campoA = this.getFieldForSorting(a, coluna);
					let campoB = this.getFieldForSorting(b, coluna);

					// Check if the fields are dates
					const isDateA = !isNaN(Date.parse(campoA));
					const isDateB = !isNaN(Date.parse(campoB));

					if (isDateA && isDateB) {
						campoA = new Date(campoA);
						campoB = new Date(campoB);
					} else {
						// Check if the fields are numbers
						const isNumberA = !isNaN(parseFloat(campoA)) && isFinite(campoA);
						const isNumberB = !isNaN(parseFloat(campoB)) && isFinite(campoB);

						if (isNumberA && isNumberB) {
							campoA = parseFloat(campoA);
							campoB = parseFloat(campoB);
						} else {
							// Otherwise, treat them as strings
							if (typeof campoA === 'string') campoA = campoA.toLowerCase();
							if (typeof campoB === 'string') campoB = campoB.toLowerCase();
						}
					}

					if (campoA < campoB) return this.ordenacao.direcao === 'asc' ? -1 : 1;
					if (campoA > campoB) return this.ordenacao.direcao === 'asc' ? 1 : -1;
					return 0;
				});
			},
			getFieldForSorting(processo, coluna) {
				if (coluna === 'autoresPrincipais') {
					// Extraia o nome do autor principal ou retorne uma string vazia se não houver
					const autorPrincipal = processo.partes.find(parte => parte.pivot.polo_ativo === 1 && parte.pivot.principal === 1);
					return autorPrincipal ? autorPrincipal.nome : '';
				}

				if (coluna === 'reus') {
					// Extraia o nome do autor principal ou retorne uma string vazia se não houver
					const reus = processo.partes.find(parte => parte.pivot.polo_passivo === 1);
					return reus ? reus.nome : '';
				}

				if (coluna === 'ultimoEvento') {
					return processo.peticoes.length > 0 ? processo.peticoes[processo.peticoes.length - 1].updated_at : '';
				}

				if (coluna === 'assuntosDescricao') {
					return processo.assuntos.length > 0 ? processo.assuntos[0].descricao : '';
				}

				return this.getNestedField(processo, coluna);
			},
			getNestedField(obj, path) {
				return path.split('.').reduce((o, p) => (o && o[p] !== 'undefined') ? o[p] : '', obj);
			},

			gerarCSV() {
				const processData = this.processosFiltrados.map(processo => {
					return {
						id: processo.id,
						codigo_processo: processo.codigo_processo,
						classe: processo.classe_processual?.descricao,
						autores_principais: processo.partes.filter(parte => parte.pivot.polo_ativo === 1 && parte.pivot.principal === 1).map(parte => parte.nome).join(', '),
						reus: processo.partes.filter(parte => parte.pivot.polo_passivo === 1).map(parte => parte.nome).join(', '),
						localidade_judicial: processo.cidade?.descricao,
						assunto: processo.assuntos.length > 0 ? processo.assuntos[0].descricao : 'Sem assunto',
						ultimo_evento: processo.peticoes.length > 0 ? this.formatDate(processo.peticoes[processo.peticoes.length - 1].updated_at) : 'Sem petições',
						data_autuacao: this.formatDate(processo.created_at),
						valor_causa: processo.valor_causa ? processo.valor_causa : 'Valor não disponível'
					};
				});

				const csvContent = [
					[
						'Codigo',
						'Numero do Processo',
						'Classe',
						'Autores Principais',
						'Reus',
						'Localidade Judicial',
						'Assunto',
						'Ultimo Evento',
						'Data de Autuacao',
						'Valor da Causa'
					],
					...processData.map(item => [
						item.id,
						item.codigo_processo,
						item.classe,
						item.autores_principais,
						item.reus,
						item.localidade_judicial,
						item.assunto,
						item.ultimo_evento,
						item.data_autuacao,
						item.valor_causa
					])
				]
					.map(e => e.join(';'))
					.join('\n');

				const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
				const link = document.createElement('a');
				const url = URL.createObjectURL(blob);
				link.setAttribute('href', url);
				link.setAttribute('download', 'processos_filtrados.csv');
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},


		},
		mounted() {
			this.CarregarClasses();
			this.CarregarDados('cidades');
			if (this.user.is_admin) {
				this.CarregarTurmas();
				this.CarregarCompetencias();
			}

		},

	};
</script>

<style scoped>
	h1 {
		font-size: 26px;
	}

	.btn_azul {
		margin-right: 3px;
		width: 90px;
		cursor: pointer;
		background-color: #007BFF;
	}

	.btn_branco {
		margin-right: 2px;
		width: 90px;
		cursor: pointer;
		background-color: white;
	}

	.btn_azul_lbl {
		color: white;
		vertical-align: middle;
		cursor: pointer;
	}

	.btn_branco_lbl {
		color: #007BFF;
		vertical-align: middle;
		cursor: pointer;
	}

	.borda_partes {
		border: 1px solid darkgray;
	}

	.custom-dropdown {
		height: 35px;
		/* Diminui a altura do campo select */
		position: relative;
		background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%22292.4%22%20height%3D%22292.4%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20viewBox%3D%220%200%20292.4%20292.4%22%20enable-background%3D%22new%200%200%20292.4%20292.4%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cg%3E%0A%3Cpath%20d%3D%22M287%2069.201a9.7%209.7%200%200%201%201.7%206.813l-4%204%20c-0.092%200.093-0.203%200.166-0.3%200.26l-127%20127c-1.8%201.801-4.501%202.701-7.1%202.701s-5.3-0.9-7.1-2.7l-127-127c-0.1-0.094-0.2-0.167-0.3-0.26l-4-4c-1.8-1.801-1.8-4.701%200-6.5%200.9-0.899%202.3-1.5%203.6-1.5h254.8c1.3%200%202.7%200.601%203.6%201.5z%22%20fill%3D%22%23000000%22/%3E%0A%3C/g%3E%0A%3C/svg%3E');
		background-position: right 0.75rem center;
		background-size: 10px 10px;
		background-repeat: no-repeat;
	}

	/* Estilo para manter o ícone de seta mesmo com o select aberto */
	.custom-dropdown:focus {}

	/* Estilo para reverter o ícone de seta padrão */
	.custom-dropdown::-ms-expand {}

	.header-content {
		display: flex;
		align-items: center;
	}

	.sort-icons {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 1px;
		/* Espaçamento entre ícones e texto */
	}

	.active {
		color: black;
		/* Cor para o ícone ativo */
		font-size: 16px;
	}

	.inactive {
		color: grey;
		/* Cor para o ícone inativo */
		font-size: 16px;
	}


	.form-container {
		border: 1px solid gray;
		/* Borda fina cinza */
		padding: 10px;
		position: relative;
		/* Posição relativa para o posicionamento do título */
		margin-top: 5px;
		/* Espaçamento superior para visualização do título */
		margin-left: 5px;
		margin-right: 1px;
		border-radius: 5px;
		background-color: #FFFFFF;
	}

	.form-title {
		position: absolute;
		/* Posicionamento absoluto do título */
		top: -15px;
		/* Posiciona o título acima da borda */
		left: 10px;
		/* Espaçamento da esquerda para o título */
		background: white;
		/* Fundo branco para o título */
		padding: 0 1px;
		/* Espaçamento interno do título */
		font-weight: bold;
	}

	.empty-results-box {
		border: 1px solid #ced4da;
		border-radius: 5px;
		color: #6c757d;
		font-size: small;
		padding: 18px;
		text-align: center;
		background-color: #fff;
	}

</style>
